import {
  AppState,
  Action,
  Asset,
  labelBoxApiEmittedNewAsset,
  labelboxApiEmittedNewCustomization,
} from '../app.reducer';
import { getImageSize } from '../../utils/image-size';
import { addId } from '../../utils/utils';
import { Tool } from '../../customization';

function parse(item: any){
  try{
    return JSON.parse(item);
  } catch(e){
    console.log('couldnt parse:', item)
    return {};
  }
}

function preloadFunction(asset: Asset) {
  const loadImageInDom = (url: string) => {
    return new Promise((resolve) => {
      const img = document.createElement('img');
      img.src = url;
      img.onload = () => {
        img.remove();
        resolve();
      };
      img.style.display = 'none';
      img.style.width = '0px';
      img.style.height = '0px';
      document.body.appendChild(img);
    });
  }
  const {imageUrl = undefined} = parse(asset.data)
  if (imageUrl) {
    return Promise.all([getImageSize(imageUrl), loadImageInDom(imageUrl)]);
  } else {
    console.log('asset.data does include json a key "imageUrl"', asset.data);
    return Promise.resolve();
  }
}


const loadCustomization = (dispatch: (action: Action) => void, customization: any) => {
  if (customization.tools || customization.classifications) {
    dispatch(labelboxApiEmittedNewCustomization({
      tools: (customization.tools || [])
        .map(addId)
        .map((tool: Tool) => {
          const classifications = tool.classifications ?
            tool.classifications.map(addId) :
            undefined;
          return {
            ...tool,
            classifications
          }
        }),
      classificationFields: (customization.classifications || []).map(addId)
    }));
  }
}

let lastAssetId: string;
export function addLabelBoxAPIListeners(
  appState: {app: AppState},
  action: Action,
  dispatch: (action: Action) => void,
){
  const Labelbox = (window as any).Labelbox;

  Labelbox.enablePreloading({preloadFunction});

  Labelbox.currentAsset().subscribe((asset: Asset | undefined) => {
    if (asset) {
      const { customization = undefined} = parse(asset.data);
      if (customization) {
        // Load the new customization whenever the tool changes
        if (asset.id !== lastAssetId){
          loadCustomization(dispatch, customization);
        }
        lastAssetId = asset.id;
      } else {
        console.log('asset.data does include json a key "customization"', asset.data);
      }
    }
    dispatch(labelBoxApiEmittedNewAsset(asset));
  });
}



// WEBPACK FOOTER //
// ./src/redux/effects/add-labelbox-api-listeners.ts